import React from "react";
import { View, StyleSheet } from "react-native";
import NtCaseStudySectionContainer from "./NtCaseStudySectionContainer";
import NtCaseStudyText from "./NtCaseStudyText";
import NtCaseStudyTextBold from "./NtCaseStudyTextBold";
import NtCaseStudyTextBullet from "./NtCaseStudyTextBullet";

function NtCaseStudyNcl(props) {
  return (
    <NtCaseStudySectionContainer
      style={styles.container}
      title={"NT Connect Maritime and Norwegian Cruise Line Case Study"}
      image={require("../../../assets/images/partners/logo_ncl.png")}
      imageStyle={{ marginLeft: -10 }}
    >
      <NtCaseStudyText>
        <NtCaseStudyTextBold>The Background</NtCaseStudyTextBold>
        {"\n\n"}Cruises offer their passengers the ability to leave their
        worries and anxieties back home, allowing them a life of luxury while
        stopping at some of the premier coastal destinations around the world.
        But while relaxation is the most important thing for most passengers,
        communication with loved ones while aboard the ship remains a primary –
        and largely unfulfilled – concern as well. In general, cruise lines have
        all sorts of communications issues while on the open ocean – especially
        when it comes to the lack of a strong internet connection. They do have
        internet capability using satellites, but it tends to be very expensive
        and thus unsustainable. To make calls to fellow passengers on the same
        ship, the call has to first travel off the ship to a satellite in space,
        back down to an earth station, over to the phone provider, and then
        finally back to the ship. Thus, it can be costly for guests to
        communicate with anyone they know on the ship, many times not knowing
        where they are until they return to their room. Also, it remains
        difficult to contact loved ones back home using commonplace tools such
        as Whatsapp and Skype via the satellite. NT Connect Maritime takes
        advantage of improved WiFi networks on the ships and more advanced
        cruise applications to offer a means to communicate with anyone on
        board. Being able to communicate onboard the ship, for a nominal fee,
        without having to buy an internet package to stay in touch with
        friends/family, is priceless.{"\n\n"}The lack of communication for
        passengers cruising may also result in missed revenue streams coming
        from in-app purchases from rooms throughout the trip. Cruise lines need
        to be able to interact with guests throughout their voyage in order to
        maximize their revenue opportunities. For this reason, Norwegian Cruise
        Line (NCL) recently approached telecommunications company NT Connect
        Maritime to help them find a solution to this problem.{"\n\n"}
        <NtCaseStudyTextBold>The Approach</NtCaseStudyTextBold>
        {"\n\n"}NT Connect Maritime has over 10 years experience in
        telecommunications and presented a solution to help Norwegian Cruise
        Line improve their telecommunications while out at sea. The Cruise
        Norwegian App, which has NT Connect Maritime’s telecommunications
        technology built-in and available on the entire Norwegian Cruise Line
        fleet, allows guests to automatically connect to the onboard wifi
        network to stay up-to-date on the comings and goings of everyone they
        are cruising with and direct calling from the app to the various guest
        services on board the ship. Guests are also given the ability to make
        off-ship calls to loved ones through the application for a nominal fee.
        With Cruise Norwegian, guests have the capability to make outbound calls
        to nearly every country in the world. In addition to being able to keep
        in contact with anyone currently on the ship, ensuring that they are
        able to know where their friends and family are at all times.{"\n\n"}
        <NtCaseStudyTextBold>The Results</NtCaseStudyTextBold>
        {"\n\n"}After initial success with one ship, NT Connect Maritime has
        gone on to deploy telecommunications on the Norwegian Cruise Line entire
        fleet of 17 ships. This case study is still in its initial stages – most
        vessels have not even been live for a year. Even so, Norwegian Cruise
        Line has seen a{" "}
        <NtCaseStudyTextBold>
          26% spike in communication package sales from passengers.
        </NtCaseStudyTextBold>{" "}
        At year’s end, this is expected to hit 50% of passengers sailing on all
        NCL ships. With access to Norwegian Cruise Line's entire fleet of 17
        ships, the Cruise Norwegian App is exposed to over 2.8M passengers per
        year. NT Connect Maritime is currently deploying its technology on NCL’s
        latest ship, NCL Encore, with a passenger capacity of 3,998 passengers –
        another 210,000 passengers per year – bringing the total number of
        potential users up to 3 million guests per year. In summary: By year’s
        end, we expect at least 1.5 million passengers out of this total to
        interact with the app per year.{"\n\n"}{" "}
        <NtCaseStudyTextBold>The Takeaways</NtCaseStudyTextBold>
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Customers enjoy and engage with the app, spending more while they are
        onboard
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Once aboard, the app helps enhance the user experience by allowing
        passengers to stay connected with friends and family onboard through the
        app’s unlimited onboard calls and messages for the duration of the
        cruise. Groups onboard can also organize meetups, stay in contact, and
        share their favorite photos with everyone in their party with group
        messaging through the app. NT Connect Maritime’s robust technology
        allows guests to enjoy a cruise vacation with greater communication and
        connectivity amongst friends and family onboard just as if they were on
        a land-based vacation.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Norweigan Cruise Lines, with the help of NT Connect Maritime, became the
        leader in communications in the cruise line industry through
        high-quality voice and messaging features.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        NT Connect installed the system in 17 ships worldwide ahead of schedule.
        Norwegian Cruise Lines wanted the deployment to take two years, but it
        only took one year while staying under budget.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Norwegian Cruise Line’s tech-first passenger mentality promotes future
        collaboration with NT Connect Maritime for future partnerships.
      </NtCaseStudyTextBullet>
    </NtCaseStudySectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtCaseStudyNcl;
